import { render, staticRenderFns } from "./FadeFooterButton.vue?vue&type=template&id=2f280cb4&scoped=true"
import script from "./FadeFooterButton.vue?vue&type=script&lang=ts"
export * from "./FadeFooterButton.vue?vue&type=script&lang=ts"
import style0 from "./FadeFooterButton.vue?vue&type=style&index=0&id=2f280cb4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f280cb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f280cb4')) {
      api.createRecord('2f280cb4', component.options)
    } else {
      api.reload('2f280cb4', component.options)
    }
    module.hot.accept("./FadeFooterButton.vue?vue&type=template&id=2f280cb4&scoped=true", function () {
      api.rerender('2f280cb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/FadeFooterButton.vue"
export default component.exports